<div class="capital-select-container" 
     [class.active]="isFocused" 
     [class.disabled]="isDisabled"
     (click)="openSelect($event, capitalSelect)">
    <span class="capital-placeholder" 
          [class.active]="value || isFocused"
          [class.no-transition]="isInitialLoad && value">
        {{ placeholder() }}</span>
    @if (value && selectedDisplayValue) {
        <span class="capital-selected-value">{{ selectedDisplayValue }}</span>
    }
    <select 
           class="capital-select" 
           [class.empty]="!value"
           [class.has-value]="!!value"
           #capitalSelect 
           [value]="value"
           [disabled]="isDisabled"
           (focus)="isFocused = true" 
           (blur)="onBlur()"
           (change)="onSelectChange($event)">
        @if (displayOptions().length > 0) {
            @for (option of options(); track $index) {
                <option [value]="option">
                    @if (option === '') {
                        {{ '' }}
                    } @else {
                        {{ displayOptions()[$index] || option }}
                    }
                </option>
            }
        } @else {
            @for (option of options(); track option) {
                <option [value]="option">{{ option }}</option>
            }
        }
    </select>
    <svg class="select-arrow" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 1.5L6 6.5L11 1.5" stroke="#53565A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</div>
